import type { ID } from '@octopus-do/octopus-project-core'
import { StorageActions } from '@store/reducers/manager/storage'
import { SeoActions } from '@store/reducers/seo/actions'
import type { SeoFormValues } from '@store/reducers/seo/types'
import type { AppState } from '@store/types'
import { useDispatch, useSelector } from 'react-redux'

import { deleteProjectAttachment } from '@/services/project'
import type { StorageState } from '@/types'

export const useDeleteImage = (nodeId: ID) => {
  const dispatch = useDispatch()

  const storage = useSelector<AppState, StorageState>(
    (state) => state.manager.storage
  )
  const form = useSelector<AppState, SeoFormValues>(({ seoForm }) => seoForm)

  return async (id?: string) => {
    const payload = storage.items.filter((item) => item.id === id)

    await Promise.all(payload.map((item) => deleteProjectAttachment(item.id)))
    dispatch(StorageActions.removeAttachments(payload))

    dispatch(
      SeoActions.change({
        id: nodeId,
        form: { ...form, image: null },
      })
    )
  }
}
